<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    include /@ibkr/lib.common/src/icon/arrow

    div(class= "inset-32 content")
            p(class="fs7 insety-8") {{ $t('cust_money_seg_para_1_1_updt') }} <a href="/en/index.php?f=2334" target="_blank" class="fg-sell">{{ $t('strength_and_security') }}</a> {{ $t('cust_money_seg_para_1_2_updt') }}
            p(class="fs7 insety-8") {{ $t('cust_money_seg_para_2') }}
            p(class="fs7 insety-8") {{ $t('cust_money_seg_para_3') }}
            p(class="fs7 insety-8") {{ $t('cust_money_seg_para_4') }}

            h3(class="insety-32") {{ $t('cust_money_seg_domestic') }}
            p(class="fs7 insety-8 content-oblique") {{ $t('all_in_millions') }}
            
            ib-table-basic.ib-row.shrink.fs7.fg70.event-border(
            :data="CommodityDomesticSegregationList",
            spacing="huge",
            height= "400px",
            ref="table",
            wrap,
            rowstripe,
            rowborder,
            colborder,
            )
                ib-table-col.event-header-border(width="15ch") {{ $t('date') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('requirement') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('funds_seg') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('excess') }}

                template(slot="body" slot-scope="row")
                    td(class="")
                        span(class="") {{ (row.date) }}
                    td(class="")
                        span(class="") {{ (row.requirement) }} 
                    td(class="")
                        span(class="") {{ (row.funds_secured) }}
                    td(class="")
                        span(class="") {{ (row.excess_deficit) }}
            


            h3(class="insety-32") {{ $t('cust_money_seg_foreign') }}
            p(class="fs7 insety-8 content-oblique") {{ $t('all_in_millions') }}
            
            ib-table-basic.ib-row.shrink.fs7.fg70.event-border(
            :data="CommodityForeignSegregationList",
            spacing="huge",
            height= "400px",
            ref="table",
            wrap,
            rowstripe,
            rowborder,
            colborder,
            )
                ib-table-col.event-header-border(width="15ch") {{ $t('date') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('requirement') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('funds_seg') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('excess') }}

                template(slot="body" slot-scope="row")
                    td(class="")
                        span(class="") {{ (row.date) }}
                    td(class="")
                        span(class="") {{ (row.requirement) }} 
                    td(class="")
                        span(class="") {{ (row.funds_secured) }}
                    td(class="")
                        span(class="") {{ (row.excess_deficit) }}

            hr(class="before-64")
            div(class="insety-16")
                ib-button(tone="sell" appearance="link" @click="getURLCFTCDisclosure") {{ $t('cftc_reg_link') }} 
                    +icon-arrow-right2
                    
            div(class="insety-16")
                ib-button(tone="sell" appearance="link" @click="getURLCFTCDetails") {{ $t('cftc_comp_detail_link') }}

                    +icon-arrow-right2    
            

            h3(class="insety-32") {{ $t('cust_money_seg_security') }}
            p(class="fs7 insety-8 content-oblique") {{ $t('all_in_millions') }}


            ib-table-basic.ib-row.shrink.fs7.fg70.event-border(
            :data="Securities15c3SegregationList",
            spacing="huge",
            height= "400px",
            ref="table",
            wrap,
            rowstripe,
            rowborder,
            colborder,
            )
                ib-table-col.event-header-border(width="15ch") {{ $t('date') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('requirement') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('funds_seg') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('excess') }}

                template(slot="body" slot-scope="row")
                    td(class="")
                        span(class="") {{ (row.date) }}
                    td(class="")
                        span(class="") {{ (row.requirement) }} 
                    td(class="")
                        span(class="") {{ (row.funds_secured) }}
                    td(class="")
                        span(class="") {{ (row.excess_deficit) }}

                    

            h3(class="insety-32") {{ $t('cust_monery_seg_cleared_swap') }}
            p(class="fs7 insety-8 content-oblique") {{ $t('all_in_millions') }}

            ib-table-basic.shrink.fs7.fg70.event-border(
            :data="CommoditySwapSegregationList",
            spacing="huge",
            ref="table",
            wrap,
            rowstripe,
            rowborder,
            colborder,
            )
                ib-table-col.event-header-border(width="15ch") {{ $t('date') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('requirement') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('funds_seg') }}
                ib-table-col.event-header-border(width="15ch") {{ $t('excess') }}

                template(slot="body" slot-scope="row")
                    td(class="")
                        span(class="") {{ (row.date) }}
                    td(class="")
                        span(class="") {{ (row.requirement) }} 
                    td(class="")
                        span(class="") {{ (row.funds_secured) }}
                    td(class="")
                        span(class="") {{ (row.excess_deficit) }}
</template>

<script>
    import api from '../api/'

    export default {
        name: 'CustomerMoneySegregationComputation',

        props:{
            CommodityDomesticSegregationList: Array,
            CommodityForeignSegregationList: Array,
            Securities15c3SegregationList: Array,
            CommoditySwapSegregationList: Array,
        },

        data() {
            return {
                
           }
        },

        methods: {
            getURLCFTCDisclosure(){
                window.location.href = "/download/Statement_of_Financial_Condition and_Supplemental_Schedules_(Audited)_12-31-14.pdf";
            },
            getURLCFTCDetails(){
                window.location.href = "/en/index.php?f=14694";
            }
  
        },

        mounted() {
            
        },

        updated(){
            
        },

        watch: {

        }
    }
</script>

<style lang="less">
.event-border{
    ._tb{
        border-style:solid;
        border-width:1px;
        border-color:rgba(0, 0, 0, 0.1);
    }
}

.event-header-border{
    border-right-style:solid;
    border-right-width:1px;
    border-right-color:rgba(0, 0, 0, 0.1);
    border-top-style:solid;
    border-top-width:1px;
    border-top-color:rgba(0, 0, 0, 0.1);
}

.content{
    border-style: solid;
    border-width: 1px;
    border-color: #6666664f;
}
</style>
